const br = {
  piano: {
    note: {
      Cb: 'Cb',
      C: 'C',
      'C#': 'C#',
      Db: 'Db',
      D: 'D',
      'D#': 'D#',
      Eb: 'Eb',
      E: 'E',
      'E#': 'E#',
      Fb: 'Fb',
      F: 'F',
      'F#': 'F#',
      Gb: 'Gb',
      G: 'G',
      'G#': 'G#',
      Ab: 'Ab',
      A: 'A',
      'A#': 'A#',
      Bb: 'Bb',
      B: 'B',
      'B#': 'B#',
    },
    numeral: {
      i: 'i',
      I: 'I',
      ii: 'ii',
      iiº: 'iiº',
      II: 'II',
      iii: 'iii',
      III: 'III',
      'III+': 'III+',
      iv: 'iv',
      IV: 'IV',
      v: 'v',
      V: 'V',
      vi: 'vi',
      viº: 'viº',
      VI: 'VI',
      viiº: 'viiº',
      VII: 'VII',
    },
  },
  scales: {
    // Maior
    'c-flat-major': 'Cb Maior',
    'c-major': 'C Maior',
    'c-sharp-major': 'C# Maior',
    'd-flat-major': 'Db Maior',
    'd-major': 'D Maior',
    'd-sharp-major': 'D# Maior',
    'e-flat-major': 'Eb Maior',
    'e-major': 'E Maior',
    'e-sharp-major': 'E# Maior',
    'f-flat-major': 'Fb Maior',
    'f-major': 'F Maior',
    'f-sharp-major': 'F# Maior',
    'g-flat-major': 'Gb Maior',
    'g-major': 'G Maior',
    'g-sharp-major': 'G# Maior',
    'a-flat-major': 'Ab Maior',
    'a-major': 'A Maior',
    'a-sharp-major': 'A# Maior',
    'b-flat-major': 'Bb Maior',
    'b-major': 'B Maior',
    'b-sharp-major': 'B# Maior',
    // Menor (Natural)
    'c-minor-natural': 'C Natural menor',
    'c-sharp-minor-natural': 'C# Natural menor',
    'd-flat-minor-natural': 'Db Natural menor',
    'd-minor-natural': 'D Natural menor',
    'd-sharp-minor-natural': 'D# Natural menor',
    'e-flat-minor-natural': 'Eb Natural menor',
    'e-minor-natural': 'E Natural menor',
    'e-sharp-minor-natural': 'E# Natural menor',
    'f-minor-natural': 'F Natural menor',
    'f-sharp-minor-natural': 'F# Natural menor',
    'g-flat-minor-natural': 'Gb Natural menor',
    'g-minor-natural': 'G Natural menor',
    'g-sharp-minor-natural': 'G# Natural menor',
    'a-flat-minor-natural': 'Ab Natural menor',
    'a-minor-natural': 'A Natural menor',
    'a-sharp-minor-natural': 'A# Natural menor',
    'b-flat-minor-natural': 'Bb Natural menor',
    'b-minor-natural': 'B Natural menor',
    'b-sharp-minor-natural': 'B# Natural menor',
    // Menor (Melódico)
    'c-minor-melodic': 'C Melódico menor',
    'c-sharp-minor-melodic': 'C# Melódico menor',
    'd-flat-minor-melodic': 'Db Melódico menor',
    'd-minor-melodic': 'D Melódico menor',
    'd-sharp-minor-melodic': 'D# Melódico menor',
    'e-flat-minor-melodic': 'Eb Melódico menor',
    'e-minor-melodic': 'E Melódico menor',
    'e-sharp-minor-melodic': 'E# Melódico menor',
    'f-minor-melodic': 'F Melódico menor',
    'f-sharp-minor-melodic': 'F# Melódico menor',
    'g-flat-minor-melodic': 'Gb Melódico menor',
    'g-minor-melodic': 'G Melodic menor',
    'g-sharp-minor-melodic': 'G# Melódico menor',
    'a-flat-minor-melodic': 'Ab Melódico menor',
    'a-minor-melodic': 'A Melódico menor',
    'a-sharp-minor-melodic': 'A# Melódico menor',
    'b-flat-minor-melodic': 'Bb Melódico menor',
    'b-minor-melodic': 'B Melódico menor',
    'b-sharp-minor-melodic': 'B# Melódico menor',
  },
  practiceModes: {
    scales: 'Escalas',
    chords: 'Acordes',
    seventhChords: 'Acordes com sétima',
    fifths: 'Quintas',
  },
  pages: {
    practice: {
      scale: {
        title: 'Escala',
        pingPongHint: 'Alternar prática de escala',
        hardModeHint: 'Alternar o modo difícil',
      },
      mode: {
        title: 'Modo',
        quizModeHint: 'Mudar para o modo quiz',
        settingsHint: 'Abrir configurações',
      },
    },
    quiz: {
      title: 'Quiz',
      questions: {
        key: 'Pressione {{key}} do seu teclado',
        fifth: 'Qual é a quinta perfeita de {{key}}',
      },
    },
  },
  settings: {
    title: 'Configurações',
    options: {
      'show-keyboard': 'Mostrar teclado',
      'mute-sound': 'Silenciar som',
      'midi-input-id': 'Entrada MIDI',
      language: 'Idioma',
      'is-sentry-on': 'Enviar relatórios de falhas',
    },
  },
}

export default br
